import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=27aba3f3&scoped=true"
import script from "./Thumbnail.vue?vue&type=script&lang=ts"
export * from "./Thumbnail.vue?vue&type=script&lang=ts"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=27aba3f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aba3f3",
  null
  
)

export default component.exports